import React from 'react';
import {
	Typography,
	Grid,
	TextField,
	Divider,
	Button,
	
} from '@material-ui/core';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { useTranslation } from 'react-i18next';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import AutoCompleteSelect from './AutoCompleteSelect';



const Spouse = ({
	handleSpouseNationaId,
	handleSpousePhone,
	handleSpouseHomeAddress,
	handleSpouseEmployerName,
	handleSpouseProfession,
	handleSpouseSalary,
	handleSpouseEmploymentType,
	handleSpouseCertificate,
	handleMaritalStatusCertificate,
	spouseNationalId,
	spousePhone,
	spouseHomeAddress,
	spouseEmployerName,
	spouseProfession,
	spouseSalarynet,
	spouseEmploymentType,
	spouseWorkCertificate,
	maritalStatusCertificate,
	fieldError,
	provinces,
	handleProvince,
	province,
	districts,
	handleDistrictLocation,
	districtLocation,
	sectors,
	sector,
	handleSector,
	handleCell,
	cells,
	cell,
	handleVillage,
	villages,
	village,
	handleSpouseProvince,
	spouseProvince,
	handleSpouseDistrict,
	spouseDistrict,
	handleSpouseSector,
	spouseSector,
	handleSpouseCell,
	spouseCell,
	handleSpouseVillage,
	spouseVillage,
	spouseSalary,
	requestSpouseNames,
	handleFirstName,
	handleLastName,
	spouseGender,
	handleGender,
	handDateOfBirth
}) => {
	const { t } = useTranslation();

	const employmentStatus = [
		{ id: 1, status: 'Self-Employed', name: `${t('self-employed')}` },
		{ id: 2, status: 'Employed', name: `${t('employed')}` },
		{ id: 3, status: 'Unemployed', name: `${t('unemployed')}` },
	];

	return (
		<div>
			<Typography variant='h6' color='initial'>
				{t('spouse-details')}
			</Typography>
			<Divider />
			{/* requestSpouseNames */}
			<TextField
				variant='outlined'
				margin='normal'
				type='text'
				fullWidth
				size='small'
				id='nationalId'
				label={t('spouse-id-number')}
				name='nationalId'
				disabled
				onChange={handleSpouseNationaId}
				defaultValue={spouseNationalId}
			/>
			{requestSpouseNames && (
				<>
					<TextField
						variant='outlined'
						margin='normal'
						type='text'
						fullWidth
						size='small'
						id='firstName'
						label={t('spouse-first-name')}
						name='firstName'
						onChange={handleFirstName}
					/>
					<TextField
						variant='outlined'
						margin='normal'
						type='text'
						fullWidth
						size='small'
						id='lastName'
						label={t('spouse-last-name')}
						name='lastName'
						onChange={handleLastName}
					/>
					<Typography>{t('date-of-birth')}</Typography>	
					<TextField
						variant='outlined'
						margin='normal'
						type='date'
						fullWidth
						size='small'
						id='dateOfBirth'
						label=""
						name='dateOfBirth'
						onChange={handDateOfBirth}
					/>
					<AutoCompleteSelect
						options={[t('male'), t('female')]}
						onChange={handleGender}
						value={spouseGender}
						label={t('gender')}
						error={fieldError}
					/>
				</>
			)}

			<div
				className={
					fieldError && fieldError === t('spousePhone-required')
						? 'overall-error'
						: 'overall-error-none'
				}
			>
				<PhoneInput
					country='rw'
					onlyCountries={['rw']}
					disableDropdown={true}
					placeholder={t('phone')}
					defaultErrorMessage='eror'
					containerStyle={{
						marginTop: '15px',
						marginBottom: '10px',
					}}
					inputStyle={{
						width: '100%',
						height: '40px',
						borderRadius: '2px',
						border: '1px solid inherit',
					}}
					inputProps={{
						name: 'phone',
						required: true,
					}}
					onChange={handleSpousePhone}
					value={spousePhone}
				/>
			</div>
			<Typography>{t('home-address')}</Typography>
			<AutoCompleteSelect
				options={provinces}
				onChange={handleSpouseProvince}
				value={spouseProvince}
				label={t('province')}
				error={fieldError}
				errorLabel={t('province-required')}
			/>
			{spouseProvince && (
				<AutoCompleteSelect
					options={districts}
					onChange={handleSpouseDistrict}
					value={spouseDistrict}
					label={t('home-district')}
					error={fieldError}
					errorLabel={t('required-district')}
				/>
			)}
			{spouseDistrict && (
				<AutoCompleteSelect
					options={sectors}
					onChange={handleSpouseSector}
					value={spouseSector}
					label={t('sector')}
					error={fieldError}
					errorLabel={t('sector-required')}
				/>
			)}
			{spouseSector && (
				<AutoCompleteSelect
					options={cells}
					onChange={handleSpouseCell}
					value={spouseCell}
					label={t('cell')}
					error={fieldError}
					errorLabel={t('cell-required')}
				/>
			)}
			{spouseCell && (
				<AutoCompleteSelect
					options={villages}
					onChange={handleSpouseVillage}
					value={spouseVillage}
					label={t('village')}
					error={fieldError}
					errorLabel={t('village-required')}
				/>
			)}
			<TextField
				variant='outlined'
				margin='normal'
				type='text'
				fullWidth
				size='small'
				id='salarynet'
				label={t('income')}
				name='salarynet'
				onChange={handleSpouseSalary}
				value={spouseSalary}
				error={
					fieldError.length > 0 && fieldError === t('spouseSalarynet-required')
				}
			/>
			<TextField
				id='employmentType'
				select
				size='small'
				margin='normal'
				variant='outlined'
				label={t('employment-status')}
				fullWidth
				onChange={handleSpouseEmploymentType}
				defaultValue={spouseEmploymentType}
				SelectProps={{
					native: true,
				}}
				error={
					fieldError.length > 0 &&
					fieldError === t('spouseEmploymentType-required')
				}
			>
				<option aria-label='None' value='' />
				{employmentStatus.length === 0
					? 'Loading...'
					: employmentStatus.map(({ id, status, name }) => (
							<option key={id} value={status}>
								{name}
							</option>
					  ))}
			</TextField>
			{spouseEmploymentType === 'Self-Employed' ||
			spouseEmploymentType === 'Employed' ? (
				<div
					className={
						fieldError && fieldError === t('spouseWorkCertificate-required')
							? 'overall-error'
							: 'overall-error-none'
					}
				>
					<Grid container direction='column'>
						<Grid item>
							<label htmlFor=''>{t('work-certificate')}</label>
						</Grid>
						<Grid item>
							<Grid container spacing={2}>
								<Grid item>
									<input
										style={{ display: 'none' }}
										id='spouseWorkCertificate'
										multiple
										type='file'
										onChange={handleSpouseCertificate}
									/>
									<label htmlFor='spouseWorkCertificate'>
										<Button
											variant='contained'
											color='default'
											component='span'
											startIcon={<CloudUploadIcon />}
										>
											Upload
										</Button>
									</label>
								</Grid>
								<Grid item>
									<Typography component='span' color='primary'>
										{spouseWorkCertificate && spouseWorkCertificate.name}
									</Typography>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</div>
			) : (
				''
			)}
			{spouseEmploymentType === 'Employed' ? (
				<>
					<TextField
						variant='outlined'
						margin='normal'
						type='text'
						fullWidth
						size='small'
						id='employer'
						label={t('employer')}
						name='employer'
						onChange={handleSpouseEmployerName}
						defaultValue={spouseEmployerName}
					/>
					<TextField
						variant='outlined'
						margin='normal'
						type='text'
						fullWidth
						size='small'
						id='profession'
						label={t('profession')}
						name='profession'
						onChange={handleSpouseProfession}
						defaultValue={spouseProfession}
						error={
							fieldError.length > 0 &&
							fieldError === t('spouseProfession-required')
						}
					/>
				</>
			) : spouseEmploymentType === 'Self-Employed' ? (
				<TextField
					variant='outlined'
					margin='normal'
					type='text'
					fullWidth
					size='small'
					id='profession'
					label={t('profession')}
					name='profession'
					onChange={handleSpouseProfession}
					defaultValue={spouseProfession}
					error={
						fieldError.length > 0 &&
						fieldError === t('spouseProfession-required')
					}
				/>
			) : (
				''
			)}

			<div
				className={
					fieldError &&
					fieldError === t('spouseMaritalStatusCertificate-required')
						? 'overall-error'
						: 'overall-error-none'
				}
			>
				<Grid container direction='column'>
					<Grid item>
						<label htmlFor=''>{t('marriage-certificate')}</label>
					</Grid>
					<Grid item>
						<Grid container spacing={2}>
							<Grid item>
								<input
									style={{ display: 'none' }}
									id='maritalStatusCertificate'
									multiple
									type='file'
									onChange={handleMaritalStatusCertificate}
								/>
								<label htmlFor='maritalStatusCertificate'>
									<Button
										variant='contained'
										color='default'
										component='span'
										startIcon={<CloudUploadIcon />}
									>
										Upload
									</Button>
								</label>
							</Grid>
							<Grid item>
								<Typography component='span' color='primary'>
									{maritalStatusCertificate && maritalStatusCertificate.name}
								</Typography>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</div>
		</div>
	);
};

export default Spouse;
